import { render, staticRenderFns } from "./CampaignResultsBanner.vue?vue&type=template&id=f3236856&scoped=true"
import script from "./CampaignResultsBanner.vue?vue&type=script&lang=js"
export * from "./CampaignResultsBanner.vue?vue&type=script&lang=js"
import style0 from "./CampaignResultsBanner.vue?vue&type=style&index=0&id=f3236856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3236856",
  null
  
)

export default component.exports